module.exports = __webpack_public_path__ + "img/promotion.62873ea2.png";